module.exports={
    "global": ["removeFromCart", "dialogOpen", "updateProductQty"],
    "storefront": ["promotionClick"],
    "search": ["productClick", "productImpression", "addToCart"],
    "product": ["productDetail", "addToCart"],
    "clp": ["productClick"]
}